// Browser-compatible logger that mimics Winston interface
class BrowserLogger {
  private formatMessage(level: string, message: any, ...args: any[]): string {
    const timestamp = new Date().toISOString().replace('T', ' ').substring(0, 19);
    const formattedMessage = typeof message === 'string' ? message : JSON.stringify(message);
    const additionalArgs = args.length > 0 ? ' ' + args.map(arg => 
      typeof arg === 'string' ? arg : JSON.stringify(arg)
    ).join(' ') : '';
    
    return `${timestamp} [${level.toUpperCase()}]: ${formattedMessage}${additionalArgs}`;
  }

  info(message: any, ...args: any[]): void {
    console.log(this.formatMessage('info', message, ...args));
  }

  error(message: any, ...args: any[]): void {
    console.error(this.formatMessage('error', message, ...args));
  }

  warn(message: any, ...args: any[]): void {
    console.warn(this.formatMessage('warn', message, ...args));
  }

  debug(message: any, ...args: any[]): void {
    console.debug(this.formatMessage('debug', message, ...args));
  }

  log(message: any, ...args: any[]): void {
    this.info(message, ...args);
  }
}

const logger = new BrowserLogger();
export default logger;
